import React, { useState } from 'react';
import axios from 'axios';
import { Button, Card, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import avatar from '../assets/images/default-avatar.jpg';

const UserDisplay = ({ user, onClose, onSuccess }) => {
  const [approving, setApproving] = useState(false);
  const [rejecting, setRejecting] = useState(false);
  const [message, setMessage] = useState('');
  const [rejectModal, setRejectModal] = useState(false);
  const [rejectionReason, setRejectionReason] = useState('');

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://api.junctionverse.com';
  const token = localStorage.getItem('accessToken');

  // --- Approve User ---
  const handleApprove = async () => {
    setApproving(true);
    try {
      await axios.post(
        `${API_BASE_URL}/admin/approve-user`,
        { userId: user.id },
        { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` } }
      );
      setMessage('User approved successfully.');
      
      // Trigger parent refresh
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      console.error('Error approving user:', err);
      setMessage('Failed to approve user.');
    } finally {
      setApproving(false);
    }
  };

  // --- Reject User ---
  const handleReject = async () => {
    if (!rejectionReason.trim()) {
      setMessage('Please provide a reason for rejection.');
      return;
    }

    setRejecting(true);
    try {
      await axios.post(
        `${API_BASE_URL}/admin/reject-user`,
        { userId: user.id, rejectionReason },
        { headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` } }
      );
      setMessage('User rejected successfully.');
      setRejectModal(false);
      
      // Trigger parent refresh
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      console.error('Error rejecting user:', err);
      setMessage('Failed to reject user.');
    } finally {
      setRejecting(false);
    }
  };

  // --- Render document images with click to open in new tab ---
  const renderImage = (label, url) => (
    url && (
      <div className="mb-3">
        <strong>{label}:</strong>
        <div>
          <img
            src={url}
            alt={label}
            style={{ maxWidth: '100%', maxHeight: '200px', borderRadius: '8px', marginTop: '5px', cursor: 'pointer' }}
            onClick={() => window.open(url, '_blank')}
          />
        </div>
      </div>
    )
  );

  return (
    <div>
      {/* User Info */}
      <Card className="mb-3 p-3">
        <Row>
          <Col md={4}>
            <img
              src={user.selfieUrl || avatar}
              alt="Profile"
              style={{ width: '100%', borderRadius: '10px', cursor: 'pointer' }}
              onClick={() => window.open(user.selfieUrl || avatar, '_blank')}
            />
          </Col>
          <Col md={8}>
            <p><strong>Full Name:</strong> {user.fullName}</p>
            <p><strong>Email:</strong> {user.email}</p>
            <p><strong>Phone Number:</strong> {user.phoneNumber}</p>
            <p><strong>University:</strong> {user.university}</p>
            <p><strong>Enrollment:</strong> {user.enrollmentMonth} {user.enrollmentYear}</p>
            <p><strong>Graduation:</strong> {user.graduationMonth} {user.graduationYear}</p>
            <p><strong>User Type:</strong> {user.userType}</p>
            <p><strong>Team Name:</strong> {user.teamName || '-'}</p>
            <p><strong>Verified:</strong> {user.isVerified ? 'Yes' : 'No'}</p>
            <p><strong>Onboarded:</strong> {user.isOnboarded ? 'Yes' : 'No'}</p>
            <p><strong>Verification Status:</strong> {user.verificationStatus || '-'}</p>
            <p><strong>Created At:</strong> {new Date(user.createdAt).toLocaleString()}</p>
          </Col>
        </Row>
      </Card>

      {/* Document Images */}
      <Card className="p-3 mb-3">
        <h5 className="mb-3">Verification Documents</h5>
        {renderImage('College ID', user.collegeIdUrl)}
        {renderImage('Aadhaar', user.aadhaarUrl)}
        {renderImage('Other Documents', user.otherDocsUrl)}
      </Card>

      {/* Approve / Reject Buttons */}
      {!user.isOnboarded && (
        <div className="text-end">
          <Button color="success" onClick={handleApprove} disabled={approving}>
            {approving ? 'Approving...' : 'Approve User'}
          </Button>{' '}
          <Button color="danger" onClick={() => setRejectModal(true)} disabled={rejecting}>
            Reject User
          </Button>
          {message && <p className="mt-2">{message}</p>}
        </div>
      )}

      {/* Reject Modal */}
      <Modal isOpen={rejectModal} size='lg' toggle={() => setRejectModal(!rejectModal)}>
        <ModalHeader toggle={() => setRejectModal(!rejectModal)}>Reject User</ModalHeader>
        <ModalBody>
          <Input
            type="textarea"
            placeholder="Enter reason for rejection"
            value={rejectionReason}
            onChange={(e) => setRejectionReason(e.target.value)}
          />
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={handleReject} disabled={rejecting}>
            {rejecting ? 'Rejecting...' : 'Reject User'}
          </Button>
          <Button color="secondary" onClick={() => setRejectModal(false)}>Cancel</Button>
        </ModalFooter>
      </Modal>

    </div>
  );
};

export default UserDisplay;
